module.exports = __webpack_public_path__ + "static/btweb-windows-screen-6f43d5c27dd03cef58f35c8b142dd461.png";